module.exports = __webpack_public_path__ + "img/child-report.ed32c4a3.svg";